import { ProjectCandidateStageCategory } from 'generated/graphql';
import {
  STAGE_CATEGORIES_WITH_COMPLETION,
  STAGE_CATEGORY_LABELS,
} from '../../Projects.constants';
import StageTypeChip from '../StageTypeChip/StageTypeChip';
import {
  CANDIDATE_STAGES_HINT,
  CandidateStageBreakdown,
  getInterviewLinkDetail,
  sortBreakdownRows,
} from './ProjectCandidatesCell.helpers';
import ProjectCandidatesTooltipSkeleton from './ProjectCandidatesTooltipSkeleton';
import styles from './ProjectCandidatesCell.module.scss';

export const PROJECT_CANDIDATES_TOOLTIP_DATA_TEST_ID =
  'project-candidates-tooltip';

const ProjectCandidatesTooltip = ({
  breakdown,
  candidatesCount,
  hasError,
  hasInterviewLinkError,
  interviewLinkCount,
  isInterviewLinkLoading,
  isLoading,
  roleStageCategories,
}: {
  breakdown?: CandidateStageBreakdown;
  candidatesCount: number;
  hasError: boolean;
  hasInterviewLinkError: boolean;
  interviewLinkCount?: number;
  isInterviewLinkLoading: boolean;
  isLoading: boolean;
  roleStageCategories: ProjectCandidateStageCategory[];
}) => (
  <div
    className={styles.tooltip}
    data-testid={PROJECT_CANDIDATES_TOOLTIP_DATA_TEST_ID}
  >
    <div className={styles.tooltipHeader}>
      <div className={styles.tooltipTotal}>
        <span>Candidates on role</span>
        <span>{candidatesCount}</span>
      </div>
      <span className={styles.tooltipSubtitle}>{CANDIDATE_STAGES_HINT}</span>
    </div>

    {hasError && (
      <span className={styles.tooltipSubtitle}>
        Couldn&apos;t load the stage breakdown.
      </span>
    )}

    {isLoading && <ProjectCandidatesTooltipSkeleton />}

    {!isLoading &&
      !hasError &&
      breakdown &&
      sortBreakdownRows(breakdown, roleStageCategories).map(row => (
        <div className={styles.tooltipRow} key={row.category}>
          <div className={styles.tooltipStage}>
            <span className={styles.tooltipStageName}>
              <StageTypeChip category={row.category} isSmall />
              {STAGE_CATEGORY_LABELS[row.category]}
            </span>
            <span>{row.candidatesCount}</span>
          </div>
          {STAGE_CATEGORIES_WITH_COMPLETION.includes(row.category) && (
            <span className={styles.tooltipDetail}>
              Completed {row.completedCount ?? 0}
            </span>
          )}
          {row.category === ProjectCandidateStageCategory.InterviewStage && (
            <span className={styles.tooltipDetail}>
              {getInterviewLinkDetail({
                hasError: hasInterviewLinkError,
                interviewLinkCount,
                isLoading: isInterviewLinkLoading,
              })}
            </span>
          )}
        </div>
      ))}
  </div>
);

export default ProjectCandidatesTooltip;
